import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  dateFormat: string = 'DD/MM/YYYY';
  timeZone: string = 'Asia/Calcutta';
  constructor() { }

  /**
   * @param milliseconds Pass milliseconds in number
   * @returns Converts the milliseconds to days hours and seconds format (eg: 1d 12h 14s)
   */

  toDaysHoursMinutes(milliseconds: number): string | number {
    const seconds =  Math.floor(milliseconds / 1000);
    const hour = (((seconds) / 60) * 0.01666667).toFixed(2);
    const secondRatio = parseFloat(hour) - Math.floor(parseFloat(hour))
    if(seconds > (3600 * 24)){
      const days = Math.floor(parseFloat(hour)/24);
      const hourRatio = (parseFloat(hour) / 24) - days
      return days + 'd ' + Math.floor(24 * hourRatio) + 'h ' + (Math.floor(60 * secondRatio)) + 'm';
    }else
    if(seconds > 3600){
      return Math.floor(parseFloat(hour)) + 'h ' + (Math.floor(60 * secondRatio)) + 'm'; 
    }else if(seconds > 60){
      return Math.floor(seconds * 0.01666667) +'m'
    }else if(seconds > 0){
      return seconds + 's'
    }else{
      return 0
    }
  }

  /**
   * 
   * @param fControl formControl of the input field
   * @param limit maximum number of input letters to be allowed
   * @returns Remaining number of letters allowed.
   */

  getFControlLength(fControl: FormControl, limit: number): number {
    return (limit - fControl.value?.length) || (fControl.value?.length ? 0 : limit)
  }
}
